import {Api, RouteConfigBuilder} from "@/calico-vue/service";
import store from "@/store";

const basePath = "/signup";

/**
 * routes
 */
const Start = () => import(/* webpackChunkName: "signup" */ "./Start");
const Member = () => import(/* webpackChunkName: "signup" */ "./Member");
const Email = () => import(/* webpackChunkName: "signup" */ "./Email");
const Confirm = () => import(/* webpackChunkName: "signup" */ "./Confirm");
const Register = () => import(/* webpackChunkName: "signup" */ "./Register");

const Routes = new RouteConfigBuilder(basePath, {
  allowAll: true,
});
export const routes = [
  Routes.baseRedirect("start"),
  Routes.component("start", Start),
  Routes.component("start/:organizationId", Start),
  Routes.component("member", Member),
  Routes.component("email", Email),
  Routes.component("confirm", Confirm),
  Routes.component("register", Register),
];

/**
 * Service
 */
const api = new Api(basePath);

export const Service = {
  memberAuth(organizationId, memberCode, dateOfBirth) {
    const form = { organizationId, memberCode, dateOfBirth };
    return api.execute("member_auth", form);
  },
  getMember() {
    const form = { registrationToken: store.state.registrationToken };
    return api.execute("get_member", form);
  },
  sendConfirmationCode(email) {
    const form = { email: email, registrationToken: store.state.registrationToken };
    return api.execute("send_confirmation_code", form);
  },
  confirmCode(code) {
    const form = { confirmationCode: code, registrationToken: store.state.registrationToken };
    return api.execute("confirm_code", form);
  },
  getSignUpInfo() {
    if (!store.state.registrationToken) {
      return new Promise(resolve => resolve(null));
    }
    const form = { registrationToken: store.state.registrationToken };
    return api.execute("get_sign_up_info", form);
  },
  register(form) {
    form.registrationToken = store.state.registrationToken;
    return api.execute("register", form);
  },
  addMember(form) {
    form.registrationToken = store.state.registrationToken;
    return api.execute("add_member", form);
  },
  prefectures() {
    return api.execute("/system/extenum/get", { type: "Prefecture" })
  }
};
